import { Link, useLocation } from "react-router-dom";
import { useHelpNav } from "@/features/help/help";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/** Docusaurus-style doc sidebar: sections with article links. */
export function HelpNav() {
  const { data, isPending } = useHelpNav();
  const { pathname } = useLocation();

  if (isPending || !data) return <Skeleton className="h-64 w-full" />;

  return (
    <nav className="space-y-6">
      {data.sections.map((s) => (
        <div key={s.section}>
          <p className="text-muted-foreground mb-2 text-xs font-semibold tracking-wide uppercase">
            {s.section}
          </p>
          <ul className="space-y-0.5">
            {s.articles.map((a) => {
              const href = `/help/${a.slug}`;
              const active = pathname === href;
              return (
                <li key={a.slug}>
                  <Link
                    to={href}
                    className={cn(
                      "flex items-center gap-2 rounded-md px-2 py-1.5 text-sm",
                      active
                        ? "bg-accent text-accent-foreground font-medium"
                        : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
                    )}
                  >
                    <span className="truncate">{a.title}</span>
                    {a.audience === "admin" && (
                      <Badge variant="outline" className="ml-auto text-[10px]">
                        Admin
                      </Badge>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}

export default HelpNav;
